import { Link } from 'react-router-dom';
import PdMark from './PdMark';

/**
 * Shared footer for authenticated and public pages.
 *
 * Deliberately low-weight: just the brand lockup, the public links
 * (Donate, Privacy, Guides, Research, For organisations, Contact) and a copyright line.
 * Intentionally does NOT repeat in-app navigation that already exists in
 * the shell.
 *
 * Layout: stacks on mobile, spreads across the row on md+.
 */
export const AppFooter = () => (
  <footer className="mt-12 bg-ground">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm">
      <div className="flex items-center gap-2.5">
        <PdMark size={20} className="text-brand" />
        <span className="font-heading font-semibold text-ink">Precious Data</span>
      </div>
      <nav className="flex flex-wrap items-center gap-x-5 gap-y-2" aria-label="Footer">
        <Link
          to="/donate"
          className="text-ink-55 hover:text-ink transition-colors duration-state"
          data-testid="footer-donate-link"
        >
          Donate
        </Link>
        <Link
          to="/privacy"
          className="text-ink-55 hover:text-ink transition-colors duration-state"
          data-testid="footer-privacy-link"
        >
          Privacy
        </Link>
        <Link
          to="/guides"
          className="text-ink-55 hover:text-ink transition-colors duration-state"
          data-testid="footer-guides-link"
        >
          Guides
        </Link>
        <Link
          to="/research"
          className="text-ink-55 hover:text-ink transition-colors duration-state"
          data-testid="footer-research-link"
        >
          Research
        </Link>
        <Link
          to="/for-organisations"
          className="text-ink-55 hover:text-ink transition-colors duration-state"
          data-testid="footer-for-orgs-link"
        >
          For organisations
        </Link>
        <a
          href="mailto:hello@preciousdata.org.uk"
          className="text-ink-55 hover:text-ink transition-colors duration-state"
          data-testid="footer-contact-link"
        >
          Contact
        </a>
      </nav>
      <p className="text-ink-55">&copy; 2026 Precious Data</p>
    </div>
  </footer>
);

export default AppFooter;
